import { TContactType } from '@cian/contact-card-component';
import { Avatar, UIHeading1, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as style from './style.css';

export interface IAgentLayoutProps {
  avatarType: TContactType;
  title: string;
  agentName: string;
  avatar: string | null;
  agentLink: string | null;
  agentHonest: React.ReactElement | null;
  agentReviews: React.ReactElement | null;
  agentProofs: React.ReactElement | null;
  linkToMoreOffers: React.ReactElement | null;
  contactButton: React.ReactElement | null;
  callButton: React.ReactElement | null;
  lifeTime: React.ReactElement | null;
}

export const AgentInfo: React.FC<IAgentLayoutProps> = ({
  avatarType,
  avatar,
  title,
  agentName,
  agentLink,
  agentHonest,
  agentReviews,
  agentProofs,
  lifeTime,
  linkToMoreOffers,
  contactButton,
  callButton,
}) => {
  return (
    <div className={style['container']}>
      <div className={style['left']}>
        <div className={style['title']}>
          <UIText2 color="black_100">{title}</UIText2>

          {agentLink ? (
            <a className={style['agent-name']} href={agentLink}>
              <UIHeading1>{agentName}</UIHeading1>
              {agentHonest && agentHonest}
            </a>
          ) : (
            <div className={style['agent-name']}>
              <UIHeading1>{agentName}</UIHeading1>
              {agentHonest && agentHonest}
            </div>
          )}
        </div>

        <div className={style['proofs']}>
          {agentReviews && agentReviews}

          {agentProofs && agentProofs}

          {lifeTime && lifeTime}

          {linkToMoreOffers && linkToMoreOffers}
        </div>

        <div className={style['buttons']}>
          {contactButton && <div className={style['button']}>{contactButton}</div>}

          {callButton && <div className={style['button']}>{callButton}</div>}
        </div>
      </div>

      <div className={style['avatar']}>
        <Avatar size={80} src={avatar} type={avatarType} />
      </div>
    </div>
  );
};
